import React, { memo, useState, useEffect } from 'react';

import styles from './BackToTop.module.less';

export default memo(props => {
  const [hidden, setHidden] = useState(true);

  const toTop = () => {
    let scroller = document.querySelector('#container_content');
    if (!scroller) return;

    let _step = scroller.scrollTop;
    const _scrollTopAnim = () => {
      let _scrollTop = scroller.scrollTop;
      if (_scrollTop <= 0) return;

      _scrollTop = _scrollTop - _step;
      _scrollTop = _scrollTop <= 0 ? 0 : _scrollTop;
      scroller.scrollTop = _scrollTop;
      requestAnimationFrame(_scrollTopAnim);
    };
    _step = _step > 100 ? Math.round(_step / 10) : _step;
    _scrollTopAnim();
  };

  useEffect(() => {
    let scroller = document.querySelector('#container_content') || document.createElement('div');

    const _scrollHandle = e => {
      if (e.target.scrollTop > e.target.offsetHeight * 2) {
        setHidden(false);
      } else {
        setHidden(true);
      }
    };

    scroller.addEventListener('scroll', _scrollHandle);
    return () => {
      scroller.removeEventListener('scroll', _scrollHandle);
    };
  }, []);

  return <div className={styles.BackToTop} hidden={hidden} onClick={toTop}></div>;
});
